import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CancelAllUploadsComponent } from '@mainrepo/app/shared-standalone-components/upload-files/cancel-all-uploads/cancel-all-uploads.component';
import { DuplicateFolderPopupComponent } from '@mainrepo/app/shared-standalone-components/upload-files/duplicate-folder-popup/duplicate-folder-popup.component';
import { FolderNameNotSupportedForUploadComponent } from '@mainrepo/app/shared-standalone-components/upload-files/folder-name-not-supported-for-upload/folder-name-not-supported-for-upload.component';
import { UploadComponent } from '@mainrepo/app/shared-standalone-components/upload-files/upload/upload.component';



@NgModule({
  imports: [
    CommonModule,
    CancelAllUploadsComponent,
    DuplicateFolderPopupComponent,
    FolderNameNotSupportedForUploadComponent,
    UploadComponent
  ],
  exports:[
    CommonModule,
    CancelAllUploadsComponent,
    DuplicateFolderPopupComponent,
    FolderNameNotSupportedForUploadComponent,
    UploadComponent
  ]
})
export class UploadOperationsModule { }
